
type IconProps = {
  className?: string; 
};

export default function RoadmapIcon({ className }: IconProps) {
    return (
        <svg className={`${className}`} viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.0417 0.791504H1.95833C1.0875 0.791504 0.382917 1.504 0.382917 2.37484L0.375 12.6111C0.375 13.1573 0.652083 13.6403 1.07167 13.9253L7.5 18.2082L13.9204 13.9253C14.34 13.6403 14.6171 13.1573 14.6171 12.6111L14.625 2.37484C14.625 1.504 13.9125 0.791504 13.0417 0.791504ZM5.91667 12.6665L1.95833 8.70817L3.07458 7.59192L5.91667 10.4261L11.9254 4.41734L13.0417 5.5415L5.91667 12.6665Z" fill="currentColor"/>
        </svg>
    );
}